import { alpha } from '@mui/material/styles';

const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  main: '#303030',
};

const SECONDARY = {
  main: '#E3E3E3',
};

const INFO = {
  lighter: '#CAFDF5',
  light: '#61F3F3',
  main: '#00B8D9',
  dark: '#006C9C',
  darker: '#003768',
  contrastText: '#FFFFFF',
};

const ALERTINFO = {
  main: '#EAF4FF',
  contrastText: '#00527C',
};

const SUCCESS = {
  lighter: '#D3FCD2',
  light: '#77ED8B',
  main: '#22C55E',
  dark: '#118D57',
  darker: '#065E49',
  contrastText: '#ffffff',
};

const BGSUCCESS = {
  main: '#277560',
};

const ALERTSUCCESS = {
  main: '#E9F1EF',
  contrastText: '#17463A',
};

const WARNING = {
  lighter: '#FFF5CC',
  light: '#FFD666',
  main: '#FFAB00',
  dark: '#B76E00',
  darker: '#7A4100',
  contrastText: GREY[800],
};

const BGWARNING = {
  main: '#FFB800',
};

const ALERTWARNING = {
  main: '#FFF1E3',
  contrastText: '#5E4200',
};

const ERROR = {
  lighter: '#FFE9D5',
  light: '#FFAC82',
  main: '#8E0B21',
  dark: '#B71D18',
  darker: '#7A0916',
  contrastText: '#FFFFFF',
};

const BGERROR = {
  main: '#F03A55',
};

const ALERTERROR = {
  main: '#F03A55',
  contrastText: '#FFFBFC',
};

const COMMON = {
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  alert: {
    success: ALERTSUCCESS,
    info: ALERTINFO,
    warning: ALERTWARNING,
    error: ALERTERROR,
  },
  text: {
    primary: '#303030',
    secondary: '#616161',
    brand: '#4A4A4A',
    success: '#17463A',
    critical: '#902333',
  },
  background: {
    success: BGSUCCESS,
    warning: BGWARNING,
    error: BGERROR,
  },
  icon: '#4A4A4A',
  grey: GREY,
  link: '#1A3893',
  opaque_link: '#A5B4E6',
  critical: '#902333',

  divider: alpha(GREY[500], 0.2),
  action: {
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha('#000000', 0.05),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export function palette(mode) {
  const light = {
    ...COMMON,
    action: {
      ...COMMON.action,
      active: GREY[600],
    },
  };

  return light;
}
